import environment from "@menu-environment";
import { rootElementId } from "@menu/core/constants";

const dthCulture = "en-dth";

const getSiteFromRootElement = () => {
    const rootElement = document.getElementById(rootElementId);
    const attributeName = "data-site";
    return rootElement && rootElement.hasAttribute(attributeName)
        ? rootElement.getAttribute(attributeName)
        : null;
}

const getSiteFromPaths = (paths: string[]) => {
    const first = paths[0];

    if (first.length === 5 && first.includes("-")) {
        return null;
    }

    return first;
}

const getDthCulture = () => {
    const queryString = window?.location?.search;
    const params = new URLSearchParams(queryString);

    return params.get("dth") ?? "";
}

export const getSiteAndCulture = () => {
    let path = window.location.pathname ?? environment.menu.defaultCulture;
    path = path.startsWith("/") ? path.substring(1) : path;

    const paths = path.split("/")

    let site = (getSiteFromRootElement() ?? getSiteFromPaths(paths));
    site = (site ?? "").toLowerCase();

    let culture = (site ? paths[1] : paths[0]) ?? "";
    culture = culture === dthCulture ? getDthCulture() : culture;
    culture = culture.split("/")[0];
    culture = culture?.length ? culture : environment.menu.defaultCulture;

    return { site, culture };
}

export default getSiteAndCulture;